/**
 * @generated SignedSource<<bb5272a6e75fd40e86bd8b750be0f6ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssemblyItemsList_ProductSkuAssemblyItem$data = {
  readonly id: string;
  readonly displayName: string;
  readonly composition: {
    readonly minQuantity: number;
    readonly " $fragmentSpreads": FragmentRefs<"AssemblyItemsListGroup_ProductSkuAssemblyItemComposition">;
  };
  readonly " $fragmentType": "AssemblyItemsList_ProductSkuAssemblyItem";
};
export type AssemblyItemsList_ProductSkuAssemblyItem$key = {
  readonly " $data"?: AssemblyItemsList_ProductSkuAssemblyItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssemblyItemsList_ProductSkuAssemblyItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AssemblyItemsList_ProductSkuAssemblyItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuAssemblyItemComposition",
      "kind": "LinkedField",
      "name": "composition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minQuantity",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AssemblyItemsListGroup_ProductSkuAssemblyItemComposition"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductSkuAssemblyItem",
  "abstractKey": null
};

(node as any).hash = "cf38ed04a547c45bc4b20b2e915c0a4d";

export default node;
